import { doMutation } from "../../core-module/util/graphqlHelper";

export const updateTrainingRegistration = ({ id, input }) => {
  const mutation = require("../api/mutation/updateTrainingRegistration.gql");
  const variables = {
    id: id,
    input: input,
  };

  return doMutation({ mutation, variables }).then(({ data, error }) => {
    if (data) {
      return { data: data.updateTrainingRegistration };
    } else if (error) return { error: JSON.stringify(error) };
  });
};
